import { render } from "./CodeView.vue?vue&type=template&id=013610c0&scoped=true"
import script from "./CodeView.vue?vue&type=script&lang=js"
export * from "./CodeView.vue?vue&type=script&lang=js"

import "./CodeView.vue?vue&type=style&index=0&id=013610c0&lang=scss&scoped=true"

import exportComponent from "/builds/customers/uid/trumpf-barcodes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013610c0"]])

export default __exports__